import { useAuth, useI18n } from '../app/context';
import { GoogleMark } from '../components/Icon';
import { Button } from '../components/ui';
import styles from './auth.module.css';

export function SignIn() {
  const { t } = useI18n();
  const { signIn, busy, error } = useAuth();

  return (
    <div className={styles.screen}>
      <div className={styles.card}>
        <div className={styles.brand}>
          <span className={styles.spines} aria-hidden="true">
            <span />
            <span />
            <span />
          </span>
          <h1 className={styles.wordmark}>{t('auth.signIn.title')}</h1>
          <p className={styles.tagline}>{t('auth.signIn.tagline')}</p>
        </div>

        {error && (
          <div className={styles.error} role="alert">
            <p>
              {error.kind === 'popup-blocked'
                ? t('auth.signIn.popupBlocked')
                : t('auth.signIn.error')}
            </p>
            {error.code && (
              <p className={styles.errorCode}>{t('auth.signIn.errorCode', { code: error.code })}</p>
            )}
          </div>
        )}

        <Button
          variant="primary"
          size="lg"
          className={styles.googleButton}
          onClick={() => void signIn()}
          disabled={busy}
        >
          <GoogleMark />
          {busy ? t('auth.signIn.busy') : t('auth.signIn.button')}
        </Button>
      </div>
    </div>
  );
}
